export enum LocalStorageKeys {
    HAS_COMPLETED_INTRODUCTORY_STEPS = 'hasCompletedIntroductorySteps',
    LAST_ACTIVITY_RECORDED_DATE = 'lastActivityRecordedDate'
}
